import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  IPredefinedText,
} from '@kinet-open-network/shared/data-access/model';

export class PredefinedText
  extends BaseModel<PredefinedText, 'PredefinedText'>
  implements IPredefinedText
{
  static override readonly modelName: AbilitySubjectType = 'PredefinedText';
  groupId!: string;
  key!: string;
  text!: string;
}
